import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const TiltFrame = ({ children, className = "" }) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const cfg = { stiffness: 120, damping: 16 };
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [12, -12]), cfg);
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), cfg);
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };
  return (
    <div className={className} style={{ perspective: 1000 }} onPointerMove={onMove} onPointerLeave={reset}>
      <motion.div style={{ rotateX, rotateY, transformStyle: "preserve-3d" }} className="h-full w-full">
        {children}
      </motion.div>
    </div>
  );
};
